import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { IOption } from '../../../../ui/interfaces/option';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ChampsFormulaireColumnName, IChampsFormulaireColumnName } from '../../champs_formulaires/champs_formulaires/champs-formulaire-column-name';
import { ChampsFormulaire, LocationType, SourceType, TypeForm } from '../../../../model/champs_formulaire/champs-formulaire.model';
import { Observable, Subject } from 'rxjs';
import { IServiceItem } from '../../../../model/service-item.model';
import { TypeInputFormModel } from '../../../../model/champs_formulaire/type-input-form.model';
import { BaseService } from '../../base/base.service';
import { ServiceItemService } from '../../service-items/service-item.service';
import { TypeInputFormService } from '../../champs_formulaires/type-input-form/type-input-form.service';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { MoniesService } from '../../monies/monies.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { ChampsFormulaireService } from '../../champs_formulaires/champs_formulaires/champs-formulaire.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { filter, map, startWith, takeUntil } from 'rxjs/operators';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { TIME_MIN_REQUEST } from '../../../../shared/constant/request.contant';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';
import { DomainColumnName, IDomainColumnName } from '../domain-column-name';
import { Domain } from '../../../../model/domain.model';
import { DomainService } from '../domain.service';

/**
 * Permet de gérer la modification des countries.
 */
@Component({
  selector: 'app-domain-liste',
  templateUrl: './domain-update.component.html',
  animations: [fadeIn]
})
export class DomainUpdateComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;
  theDialogRef: MatDialogRef<DomainUpdateComponent>;
  editForm: UntypedFormGroup;
  column: IDomainColumnName;
  private countrySelected: Domain;
  private subs$ = new Subject<void>();

  constructor(
    public baseService: BaseService,
    private accountService: AccountService,
    private dialogRef: MatDialogRef<DomainUpdateComponent>,
    private formService: FormService,
    private columnName: DomainColumnName,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    private domainService: DomainService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct domain liste');
    this.theDialogRef = this.dialogRef;
    const column = this.columnName.getColumnName();
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init domain liste');
    this.accountService.identity().pipe(takeUntil(this.subs$)).subscribe(res => {
      this.domainService.getObjetSelectObs()
        .pipe(takeUntil(this.subs$)).subscribe((res: Domain) => {
        console.log('## get domain selected to liste');
        try {
          console.log('## data: ', res);
          this.countrySelected = res;
          this.editForm.patchValue({
            [this.column.id]: res.id,
            [this.column.label]: res.label
          })
        }catch (e) {
          console.log('## error get country selected: ' + e.message);
        }
      });
    })
    super.setLoaded();
  }

  ngOnDestroy() {
    console.log('## destroy domain liste');
    this.successSave = false;
    this.formService.free(this.subs$);
    this.domainService.setObjetSelectObs(undefined);
  }

  displayFnServiceItem(subject: IServiceItem) {
    return subject ? subject.name : '';
  }

  displayFnTypeInput(subject: TypeInputFormModel) {
    return subject ? subject.type : '';
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  initForm(fb: UntypedFormBuilder, column: IDomainColumnName) {
    if (fb && column) {
      this.editForm = fb.group({
        [column.id]: [''],
        [column.label]: ['', [Validators.required]]
      })
    }
  }

  /**
   * Enregistre un type de account ressource
   */
  save() {
    console.log('## liste country');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c: Domain = this.createFromForm();
    console.log('## c: ', c);
    this.domainService.update(c, this.domainService.resourceUrl)
      .subscribe(res => {
          console.log('## success liste domain');
          this.serverHasError = false;
          this.responseFromServer();
          this.editForm.markAsPristine();
          this.successSave = true;
          this.domainService.getAllObjet();
        },
        err => {
          console.log('## error liste domain: ', err);
          this.responseFromServer();
          this.serverHasError = true;
          this.successSave = false;
        });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300)
  }

  private createFromForm(): ChampsFormulaire {
    return {
      ...new ChampsFormulaire(),
      id: this.editForm.get([this.column.id]).value,
      label: this.editForm.get([this.column.label]).value,
    };
  }

  closeModal() {
    console.log('## close domain liste');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

}
